import { useContext } from 'react'
import { AppContext, AppContextType } from '@/AppContext'
import { RoomContext, RoomContextType } from '@/RoomContext'
import { Button } from '@/UIComponents2/Button'
import BoostIcon from '@/CustomIcons/BoostIcon'
import { formatSeconds } from '@/utils'
import Tooltip from '@/UIComponents2/Tooltip'
import AlarmIcon from '@/CustomIcons/AlarmIcon'
import { useTranslation } from 'react-i18next'

const boostButtonStyle = {
    fontSize: '14px',
    borderRadius: 14,
    padding: '4px 12px',
}

function RemainingTime({ remainingTimeS }: { remainingTimeS: number | null }) {
    if (remainingTimeS == null) {
        return <></>
    }

    const SHOW_TIMER_SECONDS_THRESH = 10 * 60 // start showing the seconds remaining when less than 10 minutes
    if (remainingTimeS < SHOW_TIMER_SECONDS_THRESH) {
        const text = formatSeconds(remainingTimeS)
        return (
            <>
                <div className="w-[4ch] mr-[2px]">{text}</div> Remaining
            </>
        )
    } else {
        const text = Math.ceil(remainingTimeS / 60) + ' mins remaining'
        return <>{text}</>
    }
}

export default function SessionLimitCountdown({
    canBoost,
    remainingTimeS,
}: {
    canBoost: boolean
    remainingTimeS: number | null
}) {
    const { t } = useTranslation()
    const { dispatch: appDispatch } = useContext(AppContext) as AppContextType
    const { state: roomState } = useContext(RoomContext) as RoomContextType

    const sessionState = roomState.sessionState

    const onBoostClick = () => {
        // show boost popup
        appDispatch({
            type: 'update_app_state',
            value: {
                showUpgradeToMuseProDialog: {
                    type: 'boost',
                },
            },
        })
    }

    const tooltip = sessionState.isBoosted
        ? t('This session is boosted. You have access to Muse Pro features for 1 hour')
        : canBoost
          ? t('Boost this session to get access to Muse Pro features for 1 hour')
          : t('Not available')

    return (
        <div className="flex items-center">
            <div className="pr-1">
                <AlarmIcon style={{ fontSize: '1.3rem' }} />
            </div>
            <div className="flex pl-1 pr-3">
                <RemainingTime remainingTimeS={remainingTimeS} />
            </div>
            <Tooltip position={'bottom'} text={tooltip}>
                <Button variant="primary" style={boostButtonStyle} onClick={onBoostClick} disabled={!canBoost}>
                    {sessionState.isBoosted ? t('Boosted') : t('Boost')}
                    <div className="ml-2">
                        <BoostIcon fill="#202122" style={{ fontSize: '1.3rem' }} />
                    </div>
                </Button>
            </Tooltip>
        </div>
    )
}
